import(/* webpackMode: "eager" */ "/home/site/wwwroot/src/app/[locale]/(layout)/faq/error.js");
